export default (settings = {}) => {
  const { dayNode } = settings;
  const input = dayNode.querySelector('input');

  const state = {
    time: input.value,
    activity: 'idle',
    focusing: 'idle',
  };

  const setTime = (newTime = '') => {
    state.time = newTime;
  };

  const getTime = () => state.time;

  const setActivity = (newActivity) => {
    state.activity = newActivity;
  };

  const getActivity = () => state.activity;

  const renderActivity = () => {
    const { activity } = state;

    if (activity === 'active') {
      dayNode.classList.add('is-active');
      return;
    }

    dayNode.classList.remove('is-active');
  };

  const setFocusing = (newFocusing) => {
    state.focusing = newFocusing;
  };

  const getFocusing = () => state.focusing;

  const renderFocusing = () => {
    const { focusing } = state;

    if (focusing === 'focused') {
      dayNode.classList.add('is-focused');
      return;
    }

    dayNode.classList.remove('is-focused');
  };

  const renderValue = () => {
    const { time } = state;
    input.value = time;
  };

  const updateActivity = (newActivity = '') => {
    setActivity(newActivity);
    renderActivity();
  };

  const updateFocusing = (newFocusing = '') => {
    setFocusing(newFocusing);
    renderFocusing();
  };

  const updateTime = (newTime = '') => {
    const currentActivity = getActivity();

    if (newTime && currentActivity !== 'active') {
      updateActivity('active');
    }

    setTime(newTime);
    renderValue();
  };

  return {
    node: dayNode,
    getTime,
    getActivity,
    getFocusing,
    updateActivity,
    updateFocusing,
    updateTime,
  };
};
